export default {
    en: {
        answers: 'areas of the brain stimulate development of those areas',
        interactiveBoxNumber: [1],
        number: 5,
        diagramId: 4,
        blocks:
            [
                {
                    task: {
                        question: 'Many different areas of the brain must work together to perform music',
                        answer: '<span class="correct-answer-box">Many different <span class="highlight__answer highlight__answer_correct">areas of the brain</span> must work together to perform music</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'Active participation in music may stimulate development of those areas',
                        answer: '<span class="correct-answer-box">Active participation in music may <span class="highlight__answer highlight__answer_correct">stimulate development of those areas</span></span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'The implication for early education in the arts is clear',
                        answer: '<span class="correct-answer-box">The implication for early education in the arts is clear</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise5.js